import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDN4NzPkaPEXFXTNNVVfBKzcBat6m5SmH4",
    authDomain: "legizmo-d278c.firebaseapp.com",
    projectId: "legizmo-d278c",
    storageBucket: "legizmo-d278c.firebasestorage.app",
    messagingSenderId: "645721892193",
    appId: "1:645721892193:web:35e79e9c8015a54e879120",
    measurementId: "G-6HLRE2WSQ5"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app)

// Initialize Cloud Functions
const functions = getFunctions(app, 'us-east1')

// Initialize Storage
const storage = getStorage(app)

export {
    db,
    auth,
    functions,
    storage
}